import React from "react";
import { TextOqt } from "../";

export const EmailOqt = (props) => {
    return <TextOqt {...props} type="email" />;
}
